import React from 'react';

export const writeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="24"
    viewBox="0 0 29 24"
  >
    <defs>
      <linearGradient
        id="a"
        x1="46.978%"
        x2="37.314%"
        y1="45.457%"
        y2="29.145%"
      >
        <stop offset="40.82%" stopColor="#F2B997" />
        <stop offset="61.22%" stopColor="#EBAA87" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EBAA87"
        fillRule="nonzero"
        d="M10.49 5.97l-.433.43-6.54 6.585c-1.543 1.538-2.036 3.877-1.296 5.907L12.402 8.738l1.172 1.17 4.196-4.185c-1.913-1.908-4.998-1.908-6.972 0l-.309.246z"
      />
      <path
        fill="#46A8D8"
        fillRule="nonzero"
        d="M18.688 1.674l4.276 4.265L6.123 22.735l-4.276-4.264z"
      />
      <path
        fill="#4593C9"
        fillRule="nonzero"
        d="M20.814 3.84l2.094 2.088-16.84 16.797-2.095-2.089z"
      />
      <path
        fill="#2B66AB"
        fillRule="nonzero"
        d="M18.713 1.567l4.275 4.264-1.963 1.958-4.276-4.264z"
      />
      <path
        fill="#4593C9"
        fillRule="nonzero"
        d="M18.749 1.61l2.181 2.177-1.963 1.958-2.181-2.176z"
      />
      <path
        fill="#E1AE5C"
        fillRule="nonzero"
        d="M.987 21.354l2.222 2.154 2.9-.739-4.32-4.369z"
      />
      <path
        fill="#87513E"
        fillRule="nonzero"
        d="M.987 21.354l-.37 1.477c-.123.43.617 1.169 1.11 1.107l1.482-.369-2.222-2.215z"
      />
      <path
        fill="#EC8162"
        fillRule="nonzero"
        d="M23.632 5.292l-.617.616-4.32-4.308.618-.615c.74-.739 2.283-.37 3.455.8 1.234 1.23 1.604 2.769.864 3.507z"
      />
      <path
        fill="url(#a)"
        fillRule="nonzero"
        d="M15.672 13.17c1.173 1.6-1.049 2.892-2.9 2.83l3.517 5.354h10.86c1.049-1.97 1.851-5.539 1.604-7.939L20.98 7.938l-5.307 5.231z"
      />
      <path
        stroke="#F2B997"
        strokeLinecap="round"
        strokeWidth="5.567"
        d="M20.485 18.646H9.38"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M8.453 17.108h1.543c.493 0 .925.43.925.923v1.23a.948.948 0 0 1-.925.924H8.453v-3.077z"
        opacity=".4"
      />
    </g>
  </svg>
);
